import { render, staticRenderFns } from "./buy_bom.vue?vue&type=template&id=4b9a5208&scoped=true"
import script from "./buy_bom.vue?vue&type=script&lang=js"
export * from "./buy_bom.vue?vue&type=script&lang=js"
import style0 from "./buy_bom.vue?vue&type=style&index=0&id=4b9a5208&prod&lang=scss&scoped=true"
import style1 from "./buy_bom.vue?vue&type=style&index=1&id=4b9a5208&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a5208",
  null
  
)

export default component.exports